import React from 'react';
import { ArrowRight, Check, BadgeDollarSign, Clock, TrendingUp, Heart, BookOpen, Briefcase } from 'lucide-react';
import { Button } from '../ui/button';
import { recruitmentData } from '../../data/mock';

const benefitIcons = [BadgeDollarSign, Clock, TrendingUp, BookOpen, Heart, Briefcase];

const RecruitmentSection = () => {
  return (
    <section id="careers" className="bg-black py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border border-[#00FFD1]/30 bg-[#121212]">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left Content */}
            <div className="p-8 lg:p-12">
              <p className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase mb-4">
                Now Hiring
              </p>
              <h2 className="text-3xl sm:text-4xl font-semibold text-white leading-tight mb-6">
                {recruitmentData.headline}
              </h2>
              <p className="text-lg text-white/70 leading-relaxed mb-8">
                {recruitmentData.description}
              </p>
              
              <Button
                className="bg-[#00FFD1] text-black hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] rounded-none px-8 py-6 text-lg font-medium transition-all duration-400 inline-flex items-center gap-3"
              >
                {recruitmentData.cta}
                <ArrowRight className="w-5 h-5" />
              </Button>
            </div>

            {/* Right Content - Benefits */}
            <div className="p-8 lg:p-12 border-t lg:border-t-0 lg:border-l border-white/10">
              <h3 className="text-xl font-semibold text-white mb-6">
                Benefits of Joining Our Team
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {recruitmentData.benefits.map((benefit, index) => {
                  const Icon = benefitIcons[index] || Check;
                  return (
                    <div key={index} className="flex items-center gap-3 p-3 border border-white/10 hover:border-[#00FFD1]/30 transition-colors duration-300">
                      <Icon className="w-5 h-5 text-[#00FFD1] flex-shrink-0" />
                      <span className="text-white/85">{benefit}</span>
                    </div>
                  );
                })}
              </div>
              
              <div className="mt-8 p-4 border border-white/10 bg-black">
                <p className="text-white/60 text-sm">
                  <span className="text-[#00FFD1] font-medium">Requirements:</span> Valid Florida Class G License, clean background, and professional demeanor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentSection;
